import {STORAGE_KEYS} from "./Constants";

export const saveDeviceId = (deviceId: string) => {
    localStorage.setItem("deviceId", deviceId);
}

export const getDeviceId = (): string | null => {
    return localStorage.getItem("deviceId");
}

export const saveExchangeCode = (exchangeCode: string) => {
    sessionStorage.setItem(STORAGE_KEYS.EXCHANGE_CODE, exchangeCode);
}

export const getExchangeCode = (): string | null => {
    return sessionStorage.getItem(STORAGE_KEYS.EXCHANGE_CODE);
}

export const removeExchangeCode = () => {
    sessionStorage.removeItem(STORAGE_KEYS.EXCHANGE_CODE);
}

export const saveToken = (token: string) => {
    sessionStorage.setItem(STORAGE_KEYS.TOKEN, token);
}

export const getToken = (): string | null => {
    return sessionStorage.getItem(STORAGE_KEYS.TOKEN);
}

export const removeToken = () => {
    sessionStorage.removeItem(STORAGE_KEYS.TOKEN);
}

export const saveRefreshToken = (refreshToken: string) => {
    sessionStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
}

export const getRefreshToken = (): string | null => {
    return sessionStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
}

export const removeRefreshToken = () => {
    sessionStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
}
